import callApi from "../../utils/api";
import { API_BASE_URL, DICTIONARY_SERVICE } from "../../utils/constants";
import { parseParams } from "../../utils";
import { patchSessionGate } from "../../devtools/devtoolsState";
import {
  ACTIVITY_ANALYSER_ENDPOINTS,
  api as activityAnalyserApi,
} from "../activityReport/activityReportBaseApi";

const api = callApi(API_BASE_URL || "");
const dictionaryService = callApi(DICTIONARY_SERVICE);

const SYNONYMS_FETCH = "/api/wordnet/synonyms?word={{word}}";
const SYNONYMS_FETCH_V2 = "/api/dictionary/synonyms/{{word}}";

const COURSE_ASSIGNMENT = "/v1/api/master/courseAssignments";

const GET_COURSE_ASSIGNMENT = "/v1/api/master/courseAssignments/{{userId}}";

const ADD_ASSESSMENT_SUMMARY =
  "/v1/api/master/assignmentProgress/assessmentSummary/{{courseId}}/{{assigneeId}}";

const GET_ACTIVITIES =
  "/v1/api/master/assignmentProgress/activity/{{courseId}}/{{assigneeId}}";

const GET_PROGRESS_SUMMARY =
  "/v1/api/master/assignmentProgress/progressSummary/{{courseId}}/{{assigneeId}}";

export const UPLOAD_AUDIO = "/v1/api/file/upload-custom";
const ADD_ASSIGNMENT_ACTIVITIES = {
  course: "/v1/api/master/assignmentProgress/activity/{{courseId}}",
  courseAndAssignee:
    "/v1/api/master/assignmentProgress/activity/{{courseId}}/{{assigneeId}}",
};

const ADD_ASSIGNMENT_PROGRESS_SUMMARY = {
  course: "/v1/api/intelliread/assignmentProgress/progressSummary/{{courseId}}",
  courseAndAssignee:
    "/v1/api/master/assignmentProgress/progressSummary/{{courseId}}/{{assigneeId}}",
};

const ADD_ASSIGNMENT_ASSESSMENT_SUMMARY = {
  course:
    "/v1/api/intelliread/assignmentProgress/assessmentSummary/{{courseId}}",
  courseAndAssignee:
    "/v1/api/intelliread/assignmentProgress/assessmentSummary/{{courseId}}/{{assigneeId}}",
};

const UPDATE_SPEECH_EVALUATION_ACTIVITY = {
  // course: '/v1/api/intelliread/assignmentProgress/assessmentSummary/{{courseId}}',
  courseAndAssignee:
    "/v1/api/master/assignmentProgress/update/activity/{{courseId}}/{{assigneeId}}",
};

const RESET_COURSE_PROGRESS =
  "/v1/api/master/assignmentProgress/reset/{{courseId}}/{{assigneeId}}";

const GET_SESSION_GATE =
  "/v1/api/master/assignmentProgress/sessionGate/{{courseId}}/{{assigneeId}}";

const GET_WORD_DETAIL = "/api/dictionary/word-detail/{{word}}";
const GET_WORD_DETAIL_V2 = "/api/dictionary/{{word}}?{{query}}";

const ADD_WORD_DETAIL = "/api/dictionary/word-detail";
const ADD_WORD_DETAIL_V2 = "/api/dictionary";

export const assignCourse = async (payload) => {
  return await api.post(COURSE_ASSIGNMENT, payload.body);
};

export const getCourseAssignments = async (payload) => {
  return await api.get(
    parseParams(GET_COURSE_ASSIGNMENT, { userId: payload.userId }),
  );
};

export const addAssessmentSummary = async (payload) => {
  return await api.put(
    parseParams(ADD_ASSESSMENT_SUMMARY, payload.params),
    payload.body,
  );
};

export const addAssignmentActivitiesByCourseAndAssignee = async (payload) => {
  // SESSION_START is a session-level activity and doesn't fit the activity
  // analyser schema (which requires chapter/section IDs), so skip that emit.
  if (payload.body?.type !== "SESSION_START") {
    try {
      await activityAnalyserApi.post(
        ACTIVITY_ANALYSER_ENDPOINTS.emitActivity,
        payload.body,
      );
    } catch (e) {
      console.log("error", e);
    }
  }

  return await api.put(
    parseParams(ADD_ASSIGNMENT_ACTIVITIES.courseAndAssignee, payload.params),
    payload.body,
  );
};

export const addSpeechActivitiesByCourseAndAssignee = async (payload) => {
  try {
    await activityAnalyserApi.post(
      ACTIVITY_ANALYSER_ENDPOINTS.emitActivity,
      payload.body,
    );
  } catch (e) {
    console.log("error", e);
  }

  // return;

  return await api.put(
    parseParams(
      UPDATE_SPEECH_EVALUATION_ACTIVITY.courseAndAssignee,
      payload.params,
    ),
    payload.body,
  );
};

export const addAssignmentProgress = async (payload) => {
  return await api.put(
    parseParams(
      ADD_ASSIGNMENT_PROGRESS_SUMMARY.courseAndAssignee,
      payload.params,
    ),
    payload.body,
  );
};

export const getActivities = async (payload) => {
  return await api.get(parseParams(GET_ACTIVITIES, payload.params));
};

export const getAssessmentSummary = async (payload) => {
  return await api.get(parseParams(GET_PROGRESS_SUMMARY, payload.params));
};

export const uploadAudio = async (payload) => {
  return api.post(UPLOAD_AUDIO, payload.formData, {}, true);
};

// Per-session gate for one course (CourseGateDetail): which sessions are
// passed/failed/unattempted, their scores and attempt counts. Drives the
// in-course linear lock and retakes.
export const getSessionGate = async ({ courseId, assigneeId }) => {
  const resp = await api.get(
    parseParams(GET_SESSION_GATE, { courseId, assigneeId }),
  );
  return patchSessionGate(resp, courseId);
};

export const resetCourseProgress = async ({ courseId, assigneeId }) => {
  return await api.put(
    parseParams(RESET_COURSE_PROGRESS, { courseId, assigneeId }),
    {},
  );
};

export const getSynonyms = async (word) =>
  await dictionaryService.get(parseParams(SYNONYMS_FETCH_V2, { word }));

export const getWordDetail = async (word) =>
  await dictionaryService.get(parseParams(GET_WORD_DETAIL_V2, { word }));

export const addWordDetail = async (word) =>
  await dictionaryService.post(ADD_WORD_DETAIL_V2, word);
